var _circle, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlassLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1128_55)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1128_55)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4427 54.9502C31.5198 57.39 24.5026 59.8626 22.8489 60.4448C21.1593 61.0397 19.9135 61.5395 20.0047 61.5856C20.0941 61.6309 26.9486 63.7676 35.237 66.3339L50.3066 71L65.8574 65.5437C74.4103 62.5427 81.4494 60.051 81.4998 60.0065C81.5778 59.9379 51.2585 50.4601 51.0892 50.5001C51.0565 50.5079 45.3656 52.5105 38.4427 54.9502Z",
    fill: "#393184"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4427 54.9502C31.5198 57.39 24.5026 59.8626 22.8489 60.4448C21.1593 61.0397 19.9135 61.5395 20.0047 61.5856C20.0941 61.6309 26.9486 63.7676 35.237 66.3339L50.3066 71L65.8574 65.5437C74.4103 62.5427 81.4494 60.051 81.4998 60.0065C81.5778 59.9379 51.2585 50.4601 51.0892 50.5001C51.0565 50.5079 45.3656 52.5105 38.4427 54.9502Z",
    stroke: "url(#paint1_linear_1128_55)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1128_55)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4427 44.7002C31.5198 47.14 24.5026 49.6126 22.8489 50.1948C21.1593 50.7897 19.9135 51.2895 20.0047 51.3356C20.0941 51.3809 26.9486 53.5176 35.237 56.0839L50.3066 60.75L65.8574 55.2937C74.4103 52.2927 81.4494 49.801 81.4998 49.7565C81.5778 49.6879 51.2585 40.2101 51.0892 40.2501C51.0565 40.2579 45.3656 42.2605 38.4427 44.7002Z",
    fill: "#7165D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4427 44.7002C31.5198 47.14 24.5026 49.6126 22.8489 50.1948C21.1593 50.7897 19.9135 51.2895 20.0047 51.3356C20.0941 51.3809 26.9486 53.5176 35.237 56.0839L50.3066 60.75L65.8574 55.2937C74.4103 52.2927 81.4494 49.801 81.4998 49.7565C81.5778 49.6879 51.2585 40.2101 51.0892 40.2501C51.0565 40.2579 45.3656 42.2605 38.4427 44.7002Z",
    stroke: "url(#paint2_linear_1128_55)",
    strokeWidth: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_1128_55)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4427 34.4502C31.5198 36.89 24.5026 39.3626 22.8489 39.9448C21.1593 40.5397 19.9135 41.0395 20.0047 41.0856C20.0941 41.1309 26.9486 43.2676 35.237 45.8339L50.3066 50.5L65.8574 45.0437C74.4103 42.0427 81.4494 39.551 81.4998 39.5065C81.5778 39.4379 51.2585 29.9601 51.0892 30.0001C51.0565 30.0079 45.3656 32.0105 38.4427 34.4502Z",
    fill: "url(#paint3_linear_1128_55)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4427 34.4502C31.5198 36.89 24.5026 39.3626 22.8489 39.9448C21.1593 40.5397 19.9135 41.0395 20.0047 41.0856C20.0941 41.1309 26.9486 43.2676 35.237 45.8339L50.3066 50.5L65.8574 45.0437C74.4103 42.0427 81.4494 39.551 81.4998 39.5065C81.5778 39.4379 51.2585 29.9601 51.0892 30.0001C51.0565 30.0079 45.3656 32.0105 38.4427 34.4502Z",
    stroke: "url(#paint4_linear_1128_55)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1128_55",
    x: 17.85,
    y: 48.35,
    width: 65.7873,
    height: 24.8137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1128_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1128_55",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1128_55",
    x: 17.85,
    y: 38.1,
    width: 65.7873,
    height: 24.8137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1128_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1128_55",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_1128_55",
    x: 17.85,
    y: 27.85,
    width: 65.7873,
    height: 24.8137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1128_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1128_55",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_55",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1128_55",
    x1: 55.875,
    y1: 53.9167,
    x2: 58.8475,
    y2: 74.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1128_55",
    x1: 55.875,
    y1: 43.6667,
    x2: 58.8475,
    y2: 64.4742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1128_55",
    x1: 26.5812,
    y1: 31.8914,
    x2: 51.2456,
    y2: 70.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1128_55",
    x1: 55.875,
    y1: 33.4167,
    x2: 58.8475,
    y2: 54.2242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassLayers);
export default __webpack_public_path__ + "static/media/glass-layers.52e43bf5a90086c82cff626bc28ac334.svg";
export { ForwardRef as ReactComponent };